import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card,  } from "react-bootstrap";
import { Modal, Button, message,Tabs } from "antd";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Navbar from "./navbar";
import Footer from "../components/Footer";
import { getDocs, collection } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";

import { FaCalendarAlt, FaDollarSign, FaInfoCircle } from "react-icons/fa";

const Packages = () => {
  const [packagesList, setPackagesList] = useState([]);
  const { TabPane } = Tabs;
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showFullItinerary, setShowFullItinerary] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchPackages();
  }, []);

  useEffect(() => {
    console.log("SELECTED PACKAGE ", selectedPackage)
  }, [selectedPackage]);

  async function fetchPackages() {
    try {
      setIsLoading(true);
      const packagesCollectionRef = collection(
        db,
        "sacco",
        "qjULheMl3MrBXfGHbBl0",
        "packages"
      );
      const packagesSnapshot = await getDocs(packagesCollectionRef);
      const fetchedPackages = packagesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPackagesList(fetchedPackages);
    } catch (err) {
      message.error("Error fetching packages: " + err.message);
    } finally {
      setIsLoading(false);
    }
  }

  const filteredPackages = packagesList.filter(
    (pkg) =>
      pkg.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (pkg.category && pkg.category.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (pkg.price && pkg.price.toString().includes(searchTerm)) ||  // Added price filtering
      (pkg.days && pkg.days.toString().includes(searchTerm)) // Added days filtering
  );
  

  return (
    <>
      <Navbar />
      <div style={styles.packagesContainer}>
        <Container style={styles.container}>
          <h2 style={styles.title}>Exclusive Travel Packages</h2>

          {/* Search Filter */}
          <div style={styles.searchContainer}>
            <label htmlFor="search" style={styles.searchLabel}>
            🔍 Search Packages (by name, category, price, or days):
            </label>
            <input
              id="search"
              type="text"
              placeholder="   Search Packages (by name, category, price, or days):"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
            />
          </div>

          <Row style={styles.packageRow}>
            {isLoading ? (
              <div style={styles.loaderContainer}>
                <div style={styles.loader}></div>
                <p style={styles.loadingText}>Loading packages...</p>
              </div>
            ) : filteredPackages.length > 0 ? (
              filteredPackages.map((pkg) => (
                <Col xs={12} sm={6} md={4} key={pkg.id} style={styles.packageCol}>
                  <Card style={styles.cardStyle} className="package-card">
                    <div style={styles.imageContainer}>
                      <Card.Img
                        variant="top"
                        src={pkg.img || "/assets/default.jpg"}
                        alt={pkg.name}
                        style={styles.cardImgTop}
                      />
                      <div style={styles.priceTag}>
                        {pkg.currency} {pkg.price}
                      </div>
                    </div>
                    <Card.Body style={styles.cardBody}>
                      <Card.Title style={styles.cardTitle}>{pkg.name}</Card.Title>
                      <Button
                        variant="outline-primary"
                        style={styles.viewMoreBtn}
                        onClick={() => {
                          setSelectedPackage(pkg);
                          setActiveTab("overview");
                        }}
                      >
                        View More
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <p style={styles.noPackagesText}>No packages match your search.</p>
            )}
          </Row>
        </Container>
      </div>
      <Footer />

      {/* Modal */}
      

      <Modal
  open={!!selectedPackage}
  onCancel={() => {
    setSelectedPackage(null);
    setShowFullDescription(false);
    setShowFullItinerary(false);
  }}
  footer={null}
  centered
  width={800}
>
  {selectedPackage && (
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0, color: "#2E8B57" }}>{selectedPackage.name}</h2>
        <Button
          type="text"
          danger
          onClick={() => setSelectedPackage(null)}
          style={{ fontSize: 18 }}
        >
          ✕
        </Button>
      </div>

      <img
        src={selectedPackage.img || "/assets/default.jpg"}
        alt={selectedPackage.name}
        style={{
          width: "100%",
          height: 300,
          objectFit: "cover",
          borderRadius: 10,
          marginTop: 20,
        }}
      />

      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        style={{ marginTop: 20 }}
      >
        <Tabs.TabPane tab="Overview" key="overview">
          <p>
            <FaInfoCircle style={{ color: "#2E8B57", marginRight: 8 }} />
            <strong>Description:</strong>{" "}
            {showFullDescription || (selectedPackage.description || "").length < 250
              ? selectedPackage.description
              : `${selectedPackage.description.slice(0, 250)}... `}
            {selectedPackage.description?.length > 250 && (
              <Button
                type="link"
                onClick={() => setShowFullDescription(!showFullDescription)}
                size="small"
              >
                {showFullDescription ? "Show Less" : "Read More"}
              </Button>
            )}
          </p>

          <p>
            <FaCalendarAlt style={{ color: "#2E8B57", marginRight: 8 }} />
            <strong>Valid period:</strong> {`${selectedPackage?.validity?.value || 0} ${selectedPackage?.validity?.unit || "days"}`}
          </p>

         
        </Tabs.TabPane>

        <Tabs.TabPane tab="Itinerary" key="itinerary">
        <p>
  {/* {showFullItinerary || (selectedPackage.itenary || "").length < 250
    ?  */}
    {/* // selectedPackage.itenary || "No itinerary available." */}
    <div
            dangerouslySetInnerHTML={{ __html: selectedPackage?.itenary }}
          />
    {/* // : `${selectedPackage.itenary.slice(0, 250)}... `} */}
  {/* {selectedPackage.itenary?.length > 250 && (
    <Button
      type="link"
      onClick={() => setShowFullItinerary(!showFullItinerary)}
      size="small"
    >
      {showFullItinerary ? "Show Less" : "Read More"}
    </Button>
  )} */}
</p>

        </Tabs.TabPane>
      </Tabs>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
        <Button onClick={() => setSelectedPackage(null)}>← Back</Button>
        <a
          className="btn btn-success"
          style={{ padding: "10px 25px", borderRadius: 30 }}
          target="_blank"
          rel="noopener noreferrer"
          href={`https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=Booking%20Inquiry%20for%20${encodeURIComponent(
            selectedPackage.name
          )}&body=Hi,%0D%0AI%20am%20interested%20in%20the%20${encodeURIComponent(
            selectedPackage.name
          )}%20package.`}
        >
          Book Now
        </a>
      </div>
    </div>
  )}
</Modal>





    </>
  );
};

const styles = {
  packagesContainer: {
    padding: "40px 20px",
    backgroundColor: "#f0fff0",
    minHeight: "100vh",
  },
  container: {
    paddingTop: "40px",
  },
  title: {
    fontSize: "2rem",
    color: "#2E8B57",
    textAlign: "center",
    marginBottom: "30px",
    fontWeight: "700",
  },
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "30px",
  },
  searchLabel: {
    marginBottom: "8px",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#2E8B57",
  },
  searchInput: {
    padding: "12px 20px",
    width: "100%",
    maxWidth: "500px",
    borderRadius: "30px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
  },
  packageRow: {
    marginTop: "30px",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "20px",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
  },
  loader: {
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #2E8B57",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    animation: "spin 1s linear infinite",
  },
  loadingText: {
    color: "#2E8B57",
    marginTop: "20px",
    fontSize: "1rem",
  },
  packageCol: {
    flex: "0 1 30%",
    display: "flex",
    justifyContent: "center",
    marginBottom: "30px",
  },
  cardStyle: {
    borderRadius: "14px",
    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "white",
    maxWidth: "350px",
  },
  imageContainer: {
    position: "relative",
  },
  cardImgTop: {
    borderTopLeftRadius: "14px",
    borderTopRightRadius: "14px",
    height: "220px",
    objectFit: "cover",
  },
  priceTag: {
    position: "absolute",
    top: "10px",
    right: "10px",
    backgroundColor: "#FFD700",
    color: "#333",
    padding: "6px 16px",
    borderRadius: "30px",
    fontWeight: "bold",
  },
  cardBody: {
    padding: "20px",
    textAlign: "center",
  },
  cardTitle: {
    fontSize: "1.25rem",
    marginBottom: "15px",
    fontWeight: 600,
  },
  viewMoreBtn: {
    borderRadius: "20px",
    padding: "6px 18px",
  },
  noPackagesText: {
    textAlign: "center",
    color: "#999",
    fontSize: "1rem",
    marginTop: "40px",
  },
  tabBtn: {
    padding: "10px 20px",
    borderRadius: "20px",
    border: "1px solid #2E8B57",
    background: "transparent",
    color: "#2E8B57",
    cursor: "pointer",
    fontWeight: "600",
  },
  activeTab: {
    backgroundColor: "#2E8B57",
    color: "white",
  },
};

export default Packages;
